export default "__VITE_ASSET__BvOqGztE__"